import {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import useFocusTrap from 'utils/hooks/useFocusTrap';
import styles from './Dialog.module.scss';

export interface DialogProps {
  children: JSX.Element;
  open?: boolean;
}

function Dialog({open = false, children}: DialogProps): JSX.Element {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useFocusTrap(dialogRef);

  useEffect(() => {
    const renderedDialogElement = dialogRef.current;

    if (open) {
      renderedDialogElement?.showModal();
    } else {
      renderedDialogElement?.close();
    }
  }, [open]);

  return createPortal(
    <dialog
      className={styles.dialog}
      ref={dialogRef}
      data-open={open}
      data-testid="dialog"
    >
      {children}
    </dialog>,
    document.body,
  );
}

export default Dialog;
